export const DeviceType = {
  Dev50: "050",
  Dev51: "051",
  Dev52: "052",
} as const;

export type DeviceType = (typeof DeviceType)[keyof typeof DeviceType];
